import { useState } from 'react';
import { useNavigate } from 'react-router';
import { Title, Table, TextInput, Pagination, Loader, Alert, Box, Flex, Text, Center } from '@mantine/core';
import { IconSearch } from '@tabler/icons-react';
import { trpc } from '../lib/trpc';

const pageSize = 25;

export default function OrderList() {
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState('');

  const { data, isLoading, isError } = trpc.admin.order.list.useQuery({
    page, pageSize, search: search || undefined,
  });

  const rows = data?.rows ?? [];
  const total = data?.total ?? 0;
  const totalPages = Math.max(1, Math.ceil(total / pageSize));

  function handleSearchChange(value: string) {
    setSearch(value);
    setPage(1);
  }

  function formatDate(value: string | Date | null | undefined) {
    if (!value) return '—';
    return new Date(value).toLocaleDateString();
  }

  function formatPrice(value: string | number | null | undefined) {
    if (value === null || value === undefined) return '—';
    return Number(value).toFixed(2);
  }

  return (
    <Box>
      <Title order={2} mb="md">Orders</Title>
      <TextInput
        type="search"
        placeholder="Search by email…"
        value={search}
        onChange={(e) => handleSearchChange(e.currentTarget.value)}
        leftSection={<IconSearch size={16} />}
        w={280}
        mb="sm"
      />

      {isLoading && <Center h="60vh"><Loader /></Center>}
      {isError && <Alert color="red">Error loading orders.</Alert>}

      {!isLoading && (
        <>
          <Table highlightOnHover withTableBorder>
            <Table.Thead>
              <Table.Tr>
                {['ID', 'Customer email', 'Price with VAT', 'Status', 'Date'].map((col) => (
                  <Table.Th key={col} style={{ whiteSpace: 'nowrap' }}>{col}</Table.Th>
                ))}
              </Table.Tr>
            </Table.Thead>
            <Table.Tbody>
              {rows.map((row) => (
                <Table.Tr key={row.id} onClick={() => navigate(String(row.id))} style={{ cursor: 'pointer' }}>
                  <Table.Td>#{row.id}</Table.Td>
                  <Table.Td>{row.customerEmail ?? '—'}</Table.Td>
                  <Table.Td>{formatPrice(row.priceWithVat)}</Table.Td>
                  <Table.Td>{row.orderStatusId ?? '—'}</Table.Td>
                  <Table.Td>{formatDate(row.created)}</Table.Td>
                </Table.Tr>
              ))}
              {rows.length === 0 && (
                <Table.Tr>
                  <Table.Td colSpan={5}><Text ta="center" c="dimmed" py="md">No orders found.</Text></Table.Td>
                </Table.Tr>
              )}
            </Table.Tbody>
          </Table>

          <Flex align="center" justify="space-between" mt="md">
            <Text size="sm" c="dimmed">{total} total</Text>
            <Pagination value={page} total={totalPages} onChange={setPage} />
          </Flex>
        </>
      )}
    </Box>
  );
}
